<template src="../../../components/shared/physicianProfileAndPlans/BasePhysicianPlans.html">

</template>

<script>
    import {physcianPlansMixin} from "../../../components/shared/mixins/physicianPlansMixin.js";
    import {mapGetters} from 'vuex';
    import {common} from "../../../global/common.js";

    export default {
        name: "PhysicianPlans",
        props: {companyId: {type: [Number], required: true}, token: {type: [String], required: true}},
        mixins: [physcianPlansMixin],
        computed: {
            ...mapGetters({showPricing: 'globalSettings/showPricing'})
        },
        async mounted() {
            let url = `ProviderSearch/${this.companyId}/getProviderPlansForCompany/${this.providerEntityId}`;
            url = common.appendUrlParameter(url, 'token', this.token);
            await this.baseInit(url);
        }
    }
</script>

<style scoped>
    
</style>